module.exports = __webpack_public_path__ + "static/img/2.d81248f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i80MobileImage/2.png
// module id = 62
// module chunks = 0